"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.page.prev': 'Poprzednia',
    'dblogs.page.next': 'Następna',
    'dblogs.page.info': 'Strona',
};
